import React from 'react';
import { BaseCellProps } from './../helpers/CellHelpers';
import './BasicCell.scss';

interface BasicCellProps extends BaseCellProps {
  value: string;
}

const BasicCell: React.FC<BasicCellProps> = ({
  value = '',
  truncate = false,
  isBold = false,
}) => {
  let nValue = value === null ? '' : value;
  const wordBreakClas = truncate ? 'break-word ' : '';
  const boldCls = isBold ? 'bold-cell' : 'basic-cell';
  return <td className={boldCls + wordBreakClas}>{nValue}</td>;
};

export default BasicCell;
